<template>
    <header>
      <div class="top">
        <div class="container">
          <div class="top-box">
            <div class="top-announce" @click="$router.push({name: 'notice'})">
              <div class="announce-text">站内公告</div>
              <div class="announce-icon">
                <img src="@/static/images/icons/notice.png" class="announce-icon-img" />
                <span class="icon_dot" v-if="false">
                  <span class="icon_dot_inner">1</span>
                </span>
                <span class="icon_dot_small"></span>
              </div>
            </div>
            <div class="nav-link">
              <template v-if="userLogin">
                  用户：{{user.phone}}
                  <el-button type="text" plain @click="onLogout" class="btn-logout">退出</el-button>
                </template>
                <template v-else>
                  <router-link to="/login">
                    登陆
                  </router-link>
                  <router-link to="/register">注册</router-link>
                </template>
                <router-link to="/user/order">我的订单</router-link>
                <router-link to="/user">用户中心</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="s-box">
        <div class="container">
          <div class="logo">
            <img src="@/assets/images/logo0525.jpeg" @click="$router.push({name: 'home'})">
          </div>
          <div class="search-box">
            <div class="search">
              <div class="search-input">
                <el-input v-model="key" class="input-search" placeholder="请输入内容"></el-input>
              </div>
              <div class="search-btn">
                <el-button type="danger" class="btn-search" @click="onSearch">搜索</el-button>
              </div>
            </div>
            <div class="keyword-list">
              <!-- <router-link to="/?key=华为">华为</router-link>
              <router-link to="/?key=iPhone">iPhone</router-link>
              <router-link to="/?key=小米">小米</router-link>
              <router-link to="/?key=oppo">OPPO</router-link> -->
            </div>
          </div>
          <div class="cart-box">
            <el-button v-if="cartButton" type="danger" plain class="btn-cart" @click="$router.push({name: 'cart'})">
              <i class="el-icon-s-goods"></i>
              我的购物车
            </el-button>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="nav clear">
        <div class="container">
          <div class="nav-box">
            <div class="menu-box">
              <router-link to="/" :class="{'select': !$route.query.cid}">首页</router-link>
              <router-link to="/?cid=1" :class="{'select': $route.query.cid === '1'}">手机</router-link>
              <router-link to="/?cid=2" :class="{ 'select': ($route.query.cid === '2')}">平板</router-link>
              <router-link to="/?cid=3" :class="{'select': $route.query.cid === '3'}">笔记本</router-link>
              <router-link to="/?cid=4" :class="{'select': $route.query.cid === '4'}">显卡</router-link>
              <router-link to="/?cid=5" :class="{'select': $route.query.cid === '5'}">其他</router-link>
            </div>
            <div class="tel-box">
            </div>
          </div>
        </div>
      </div>
    </header>
</template>
<script>
import { getItemObject,removeAll,removeItem } from '../utils/storage'
import {logout} from '../api/server/auth'
import commonMixin from '@/mixin/common'
export default {
  name: 'NavComponent',
  mixins: [commonMixin],
  data () {
    return {
      key: null,
      // user: null,
      userLogin: false,
      cartButton: true,
    }
  },
  methods: {
    onSearch () {
      if (!this.key) {
        this.warning('请输入关键词')
        return false
      } else {
        this.$router.push({name: 'home', query: {key: this.key} })
      }
      this.success(this.key)
    },
    onLogout () {
      logout().then( (res) => {
        if (res.code === 200) {
          removeItem('userinfo')
          removeAll()
          this.success('退出登陆成功')
          this.$router.push({name: 'login'})
        }
      })
    },
    updateUser () {
      this.user = getItemObject('userinfo')
      if (this.user && this.user.isLogin) {
        this.userLogin = true
      } else {
        this.userLogin = false
      }
    },
    reset () {
      this.cartButton = true
      this.updateUser()
    },
    handleRoute (route) {
      this.reset()
      if (route.name === 'cart') {
        this.cartButton = false
      } else {
        this.cartButton = true
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
}
</script>
<style lang="scss">
.btn-logout {
  color: #000000 !important;
  font-weight: normal !important;
  border: 0 !important;
  margin-left: 15px !important;
  padding: 0;
}
.top-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .top-announce {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    .announce-icon {
      margin-left: 3px;
      height: 22px;
      position: relative;
      cursor: pointer;
      .announce-icon-img {
        width: 18px;
        height: 18px;
      }
      .icon_dot_small {
        border-radius: 50%;
        width: 10px;
        height: 10px;
        background-color: #ff5027;
        color: #ffffff;
        position: absolute;
        top: -4px;
        left: 11px;
      }
      .icon_dot {
        border-radius: 11px;
        padding: 0 8px;
        height: 18px;
        background-color: #ff5027;
        line-height: 17px;
        color: #ffffff;
        font-size: 12px;
        position: absolute;
        top: -4px;
        left: 11px;
        .icon_dot_inner {
          display: block;
          position: relative;
          z-index: 1;
          margin: 0 -2px;
        }
      }
    }
    .announce-text {
      font-size: 14px;
    }
  }
}
</style>
